import React from "react";

import { Flex, Icon, Tag, TagColour, Tooltip } from "components";

export const CardContentGroup = ({
  title,
  description,
  largeDescription = false,
  tag,
  tooltipTitle,
  align = "left",
  grow = false,
  tagPosition = "top",
}: {
  title: string | number;
  description?: string;
  largeDescription?: boolean;
  grow?: boolean;
  align?: "left" | "center" | "right";
  tooltipTitle?: string;
  tag?: null | { text: string; colour: TagColour; tooltip?: string }[];
  tagPosition?: "top" | "inline";
}) => (
  <Flex className={`${grow ? "flex-1" : ""} footprint-button-card-column ${align}`} vertical justify="center">
    {tagPosition === "top" && tag && tag.length > 0 ? (
      <Flex className="tag-wrapper" justify="center" gap={4}>
        {tag.map((tagItem, index) => (
          <Tooltip key={index} disabled={!tagItem.tooltip} placement="top" title={tagItem.tooltip}>
            <Tag className="footprint-button-tag top" text={tagItem.text} colour={tagItem.colour} />
          </Tooltip>
        ))}
      </Flex>
    ) : null}
    {tagPosition === "inline" ? (
      <Flex className="paragraph-l margin-0 padding-0" align="center" gap={8} wrap>
        <span className="paragraph-l margin-0 padding-0">{title}</span>
        {tag &&
          tag.length > 0 &&
          tag.map((tagItem, index) => (
            <Tooltip key={index} disabled={!tagItem.tooltip} placement="top" title={tagItem.tooltip}>
              <Tag className="footprint-button-tag" text={tagItem.text} colour={tagItem.colour} />
            </Tooltip>
          ))}
      </Flex>
    ) : (
      <p className="paragraph-l margin-0 padding-0">{title}</p>
    )}
    <Tooltip disabled={tooltipTitle === undefined} placement="bottom" title={tooltipTitle}>
      <p className={`${largeDescription ? "paragraph-m margin-top-25" : "paragraph-s"}  grey-600-text margin-0 padding-0`}>
        {description} {tooltipTitle ? <Icon size="s" iconName="tabler/info-circle" className="icon inline" /> : null}
      </p>
    </Tooltip>
  </Flex>
);
